export * from "./venues";

// Auth-related constants
export const AUTH_TOKEN_KEY = "authToken";
export const REFRESH_TOKEN_KEY = "refreshToken";
export const TRPC_ENDPOINT = "/api/trpc";
